/**
 * This is a complete list of all links to the docs. To create a new doc link, please add it to this array.
 *
 * This list is kept complete here, so we can:
 * 1. Automate the process of creating new doc links in our URL shortener.
 * 2. Check for any dead links.
 */
const ALL_VERSIONED_DOC_LINK_SLUGS = [
	"configure-smtp",
	"rancher-prime-learn-more",
	"rancher-prime-upgrade",
	"ui-dashboards",
	"ui-events-perspective",
	"ui-highlights-perspective",
	"ui-indirect-relations",
	"ui-k8s-custom-views",
	"ui-k8s-views",
	"ui-metrics-perspective",
	"ui-monitors-docs",
	"ui-monitors-silencing",
	"ui-override-monitor-arguments",
	"ui-overview-perspective",
	"ui-popover-identifiers-help",
	"ui-service-tokens",
	"ui-sts-cli-manual-install",
	"ui-time-interval-limit",
	"ui-topology-advanced-filter-pane-learn-more",
	"ui-topology-perspective-too-many-components-filtering-limits",
	"ui-topology-perspective",
	"ui-topology-time",
	"ui-traces-perspective", //TODO STAC-20940: update slug
] as const;

const ALL_NOT_VERSIONED_DOC_LINK_SLUGS = ["ui-get-started-popup-link", "video"] as const;

const ALL_SLUGS = [...ALL_VERSIONED_DOC_LINK_SLUGS, ...ALL_NOT_VERSIONED_DOC_LINK_SLUGS];

export type DocLinkSlug = (typeof ALL_SLUGS)[number];

const VERSIONED_SLUGS_SET = new Set<string>(ALL_VERSIONED_DOC_LINK_SLUGS);

const isVersionedDocLink = (slug: DocLinkSlug): boolean => VERSIONED_SLUGS_SET.has(slug);

export const TRIAL_LINK = "https://www.stackstate.com/trial-sign-up";

export function doCreateDocLinkUrl(versionedUrlPrefix: string, slug: DocLinkSlug): string {
	return `${isVersionedDocLink(slug) ? versionedUrlPrefix : "https://l.stackstate.com/"}${slug}`;
}

// These function are used by scripts/check-links.sh to do link checking
/**
 * @private
 */
export function produceAllLinks(): void {
	ALL_SLUGS.forEach((slug) => {
		// biome-ignore lint/suspicious/noConsole: used in .sh script
		console.log(doCreateDocLinkUrl("https://l.stackstate.com/v7.0/", slug));
	});
}

/**
 * @private
 */
export function produceAllSlugs(): void {
	ALL_SLUGS.forEach((slug) => {
		// biome-ignore lint/suspicious/noConsole: used in .sh script
		console.log(slug);
	});
}
